/**
 * @file useStyleTransform
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { useCallback, useEffect } from 'react';
import { shallowMerge } from '@tencent/glue-util-helper';
import { useSafeInit, useSingleton, useUpdate } from '@tencent/glue-react-use';
import { StyleTransform } from '../lib/StyleTransform';
import { useClassTransform } from './useClassTransform';
import { usePixelInstance } from '../context/pixel';
export function useStyleTransform(elementStyle) {
    var classList = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        classList[_i - 1] = arguments[_i];
    }
    var _a = useClassTransform(classList), classStyle = _a[0], restClassName = _a[1];
    var pixel = usePixelInstance();
    var transform = useSingleton(function () { return new StyleTransform(pixel); });
    var ref = useCallback(function (el) { return transform.setElement(el); }, []);
    var update = useUpdate();
    useSafeInit(function () {
        transform.addListener('refresh', update);
        return function () { return transform.removeListener('refresh', update); };
    });
    useEffect(function () { return transform.commit(); }, []);
    transform.setStyle(shallowMerge(classStyle, elementStyle));
    return {
        className: restClassName,
        style: transform.getStyle(),
        ref: ref,
    };
}
